<script lang="ts">
	import { Background } from "@components/Background.js";
	import BookMeeting from "@components/BookMeeting.svelte";
	import InfoCard from "@components/InfoCard.svelte";
	import Section from "@components/Section.svelte";
	import TechnologyCards from "@components/TechnologyCards.svelte";
	import Formatted from "@components/common/Formatted.svelte";
	import Icon from "@components/common/Icon.svelte";
	import Link from "@components/common/Link.svelte";
	import { ButtonVariant } from "@components/common/getButtonClass.js";
	import Layout from "@components/layout/Layout.svelte";
	import arrowNext from "@core/assets/icons/arrow-next.svg?raw";
	import { getConnectWithFastestPath } from "@core/schema/paths/getConnectWithFastestPath.js";
	import { getGlobalTemplateProps } from "../contexts/getGlobalTemplateProps.js";
	import { BookMeetingPerson, getBookMeetingPeople } from "../data/getBookMeetingPeople.js";
	import { getServerlessTechnologyBenefits } from "../data/getServerlessTechnologyBenefits.js";
	import { getTechnologies } from "../data/getTechnologies.js";
	import type { TechnologiesProps } from "./TechnologiesProps.js";

	const { tenant } = getGlobalTemplateProps();
	const _: TechnologiesProps = $props();
</script>

<Layout>
	<Section background={Background.LightGradient} centered gridHeadline="container-6" gridDesc="container-6" hero>
		{#snippet headline()}
			<Formatted text="Využíváme cg[[moderní technologie]] a vyvíjíme na cloudu" />
		{/snippet}
		{#snippet desc()}
			<p>
				<Formatted
					text="Software na míru vyvíjíme primárně na cloudu AWS, čímž vám zajistíme vyšší bezpečnost a ušetříme náklady za dedikované servery. sp[[Pracujeme s moderními a ověřenými technologiemi, které nabízí ideální poměr cena/výkon.]]"
				/>
			</p>
		{/snippet}
		{#snippet cta()}
			<Link
				variant={ButtonVariant.PhloxOutlineLightBg}
				class="flex items-center justify-center mx-auto mt-2"
				href={getConnectWithFastestPath(tenant)}
			>
				<Formatted text="Chci fastest služby" />
				<Icon icon={arrowNext} class="ml-2.5 text-fstgrey-900 w-5"></Icon>
			</Link>
		{/snippet}
	</Section>

	<Section
		gridHeadline="container-12 md:container-8 xl:container-start-2 xl:container-end-5"
		gridDesc="container-12 md:container-8 xl:container-start-7 xl:container-end-10"
		paddingFollowNext
		background={Background.LightGradient}
	>
		{#snippet headline()}
			<Formatted text="Nejbližší jsou nám technologie ze světa cg[[JavaScriptu]]" />
		{/snippet}
		{#snippet desc()}
			<p>
				<Formatted
					text="Vytváření moderních a škálovatelných aplikací na míru vyžaduje používání jak nových, tak dlouhodobě osvědčených technologií. sp[[A přesně to ve Fastest děláme.]] "
				/>
			</p>
			<p>
				<Formatted
					text="Naši vývojáři mají zkušenosti s celou řadou programovacích jazyků a nástrojů (včetně C++, C# nebo Pythonu). Nejčastěji využíváme ty, které vzešly z JavaScriptu – Angular, Svelte, React nebo Node.JS."
				/>
			</p>
		{/snippet}
	</Section>

	<TechnologyCards technologies={getTechnologies(tenant)} />

	<Section
		background={Background.LightGradient}
		paddingFollowNext
		gridHeadline="container-8 lg:text-center"
		gridDesc="container-8"
		centered
	>
		{#snippet headline()}
			<Formatted text="cg[[Bezserverový vývoj]] je bezpečnější a úspornější" />
		{/snippet}
		{#snippet desc()}
			<p>
				<Formatted
					text="Vysoké náklady na pořízení i údržbu hardwaru, nedostatečné zabezpečení nebo náročná škálovatelnost. I to jsou důvody, proč software většinou nevyvíjíme na fyzických serverech, sp[[ale na cloudu AWS (Amazon Web Services).]] "
				/>
			</p>
		{/snippet}
	</Section>
	<Section gridChildren="max-md:full-width" background={Background.White} noPadding="both">
		<div
			class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-1 max-lg:full-width lg:px-1 bg-fstlight-100 border-t-4 border-fstlight-100"
		>
			{#each getServerlessTechnologyBenefits(tenant) as { title, desc }, index (index)}
				<InfoCard {title} {desc} indexNumber={index + 1} />
			{/each}
		</div>
	</Section>
	<Section noPadding="top">
		<Link
			variant={ButtonVariant.Phlox}
			class="flex items-center justify-center mx-auto mt-8 lg:mt-12"
			href={getConnectWithFastestPath(tenant)}
		>
			<Formatted text="Zeptat se na podrobnosti" />
			<Icon icon={arrowNext} class="ml-2.5 text-fstgrey-900 w-5"></Icon>
		</Link>
	</Section>

	{@const contacts = getBookMeetingPeople(tenant)}
	<BookMeeting contacts={[contacts[BookMeetingPerson.Kucera]]} />
</Layout>
